import { YearMonthFns } from '../utils/datetime'
import { DatePickerDay } from './date-picker-day'
import { DatePickerMonth } from './date-picker-month'
import { DatePickerRoot } from './date-picker-root'
import { useDatePicker } from './use-date-picker'
import { DatePickerPrev } from './date-picker-prev'
import { DatePickerNext } from './date-picker-next'

export type { DatePickerRootProps as HeadlessDatePickerProps } from './date-picker-root'

export const HeadlessDatePicker = Object.assign(DatePickerRoot, {
  Day: DatePickerDay,
  Month: DatePickerMonth,
  Prev: DatePickerPrev,
  Next: DatePickerNext,
  getCalendarDays,
  useDatePicker: useDatePicker
})

function getCalendarDays(month: string): string[] {
  const startingDayOfWeek = YearMonthFns.getStartingDayOfWeek(month)
  const daysInMonth = YearMonthFns.getDaysInMonth(month)
  const daysInPrevMonth = YearMonthFns.getDaysInMonth(YearMonthFns.getPrev(month))

  const days = Array.from({
    length: startingDayOfWeek + daysInMonth + 7 - ((startingDayOfWeek + daysInMonth) % 7 || 7)
  }).map((_, i) => {
    if (i < startingDayOfWeek) {
      const day = daysInPrevMonth - startingDayOfWeek + i + 1
      return `${YearMonthFns.getPrev(month)}-${((day || 0) > 9 ? '' : '0') + day}`
    } else if (i >= startingDayOfWeek + daysInMonth) {
      const day = i + 1 - startingDayOfWeek - daysInMonth
      return `${YearMonthFns.getNext(month)}-${((day || 0) > 9 ? '' : '0') + day}`
    } else {
      const day = i - startingDayOfWeek + 1
      return `${month}-${((day || 0) > 9 ? '' : '0') + day}`
    }
  })

  return days
}
